import type { NumberInputT, SelectInputT, SimpleStyleT } from "tweenly"
import CompactSelect from "../../../common/PropertyTools/CompactSelect"
import PrefixedInput from "../../../common/PropertyTools/PrefixedInput"

interface Props {
    state: "from" | "to"
    animationState: SimpleStyleT
    /** what the field is, for the hover tooltip — its caption and column say it on screen */
    tooltip: string
    /** the property's name shown inside the field */
    label: string
    handleSetValue: (e: any, state: "from" | "to") => void
}

/** One property of a tween's from / to state as a compact field, its unit at the end. */
const AnimationState = ({ state, animationState, tooltip, label, handleSetValue }: Props) => {
    const handleAnimationStateChange = (e: any) => handleSetValue(e, state)
    const unit = animationState.unit

    if (animationState.input.type === "number") {
        const limits = (animationState.input as NumberInputT).props?.inputProps
        return (
            <PrefixedInput
                name={animationState.property}
                value={animationState.value}
                label={label}
                tooltip={tooltip}
                handleOnChange={handleAnimationStateChange}
                min={limits?.min}
                max={limits?.max}
                step={limits?.step}
                endAdornment={unit}
            />
        )
    }
    if (animationState.input.type === "string")
        return (
            <PrefixedInput
                name={animationState.property}
                value={animationState.value}
                type="text"
                label={label}
                tooltip={tooltip}
                handleOnChange={handleAnimationStateChange}
            />
        )
    if (animationState.input.type === "select")
        return (
            <CompactSelect
                name={animationState.property}
                value={String(animationState.value)}
                options={(animationState.input as SelectInputT).props.map((option) => ({
                    value: option,
                    label: option,
                }))}
                label={label}
                tooltip={tooltip}
                handleOnChange={handleAnimationStateChange}
            />
        )
    return <></>
}

export default AnimationState
